import React from "react";

export const VisionMissionValues = () => {
  return (
    <section
      id="vision"
      data-testid="vision-mission-section"
      className="bg-brand-off-white text-brand-teal py-24 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Heading row */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 mb-20">
          <div className="md:col-span-3">
            <span className="overline text-[#2EC4B6]">— Who we are</span>
          </div>
          <div className="md:col-span-9">
            <h2
              className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.05]"
              data-testid="vision-section-heading"
            >
              A consulting house built on
              <span className="text-[#2EC4B6]"> trust, transparency </span>
              and a relentless drive for impact.
            </h2>
          </div>
        </div>

        {/* Tetris grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-px bg-brand-teal/10">
          {/* Vision */}
          <article
            data-testid="vision-card"
            className="md:col-span-7 bg-brand-off-white p-10 md:p-14 group transition-colors duration-500 hover:bg-brand-teal hover:text-white"
          >
            <div className="overline text-[#2EC4B6] mb-6">Vision</div>
            <p className="font-display-medium text-2xl md:text-3xl leading-snug tracking-tight">
              To become a global consulting firm recognised for its expertise,
              real impact and transparency with clients.
            </p>
          </article>

          {/* Values list */}
          <aside
            data-testid="values-card"
            className="md:col-span-5 bg-brand-teal text-white p-10 md:p-14"
          >
            <div className="overline text-[#2EC4B6] mb-6">Values</div>
            <ul className="space-y-5">
              {[
                "Transparency in every conversation",
                "Striving for measurable impact",
                "Collaborative excellence over ego",
                "Continuous learning, even from failure",
              ].map((v, i) => (
                <li
                  key={v}
                  data-testid={`value-item-${i}`}
                  className="flex items-start gap-4 text-lg md:text-xl font-display-medium"
                >
                  <span className="h-2 w-2 rounded-full bg-[#2EC4B6] mt-3 shrink-0" />
                  <span className="text-white/90">{v}</span>
                </li>
              ))}
            </ul>
          </aside>

          {/* Mission */}
          <article
            data-testid="mission-card"
            className="md:col-span-12 bg-white p-10 md:p-14"
          >
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
              <div className="md:col-span-3">
                <div className="overline text-[#2EC4B6]">Mission</div>
              </div>
              <p className="md:col-span-9 font-display-medium text-2xl md:text-4xl leading-tight tracking-tight">
                We exist because we know how to
                <span className="text-[#2EC4B6]"> listen </span>
                to our clients, understand
                <span className="text-[#2EC4B6]"> when and how </span>
                to help them, and stay open to collaborating with people more
                experienced than ourselves.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionValues;
